import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileComponent } from './pages/profile/profile.component';
import { PatientScheduleStatusComponent } from './pages/schedule/status/schedule-status.component';
import { PatientScheduleComponent } from './pages/schedule/schedule.component';
import { ScheduleAppointmentPatientComponent } from './pages/schedule/appointment/schedule-appointment.component';
import { ScheduleProcedurePatientComponent } from './pages/schedule/procedure/schedule-procedure.component';
import { FirstAccessGuard } from 'app/core/guards/first-access.guard';
import { ScheduleComponent } from 'app/pages/schedule/schedule.component';
import { ProcedureBySpecialistComponent } from './pages/schedule/procedure-by-specialist/procedure-by-specialist.component';
import { UserTypeGuard } from 'app/core/guards/user-type.guard';
import { AuthGuard } from 'app/core/guards/auth.guard';

const routes: Routes = [
  { path: '', component: ScheduleComponent, canActivate: [FirstAccessGuard] },
  {
    path: 'agendar',
    component: PatientScheduleComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "patient"
    }
  },
 
  {
    path: 'agenda/status',
    component: PatientScheduleStatusComponent,
    canActivate: [FirstAccessGuard,  AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "patient"
    }
    
  },
  {
    path: 'agendar/consulta',
    component: ScheduleAppointmentPatientComponent,
    canActivate: [FirstAccessGuard,  AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "patient"
    }
  },
  {
    path: 'agendar/exame',
    component: ScheduleProcedurePatientComponent,
    canActivate: [FirstAccessGuard,  AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "patient"
    }
  },
  {
    path: 'agendar/clinicas',
    component: ScheduleProcedurePatientComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "patient"
    }
  },
  {
    path: 'agendar/especialistas/exame',
    component: ProcedureBySpecialistComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "patient"
    }

  },
  { 
    path: 'meus-dados', component: ProfileComponent, 
    canActivate: [ AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "patient"
    }},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PatientRoutingModule {}
